module.exports = __webpack_public_path__ + "static/vetorizador-demo-fb3033b114dc8527edc7e56747a080ae.mp4";